import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { DateRangeOptionType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/DateRangeOptionType";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { FilterType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/FilterType";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

import { DashboardFilterDispatcher } from "./Variable";
import { ClientDashboardFiltersModel } from "../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { DashboardTab, DateRangeOptionTypeMap } from "../Resource/Content";
import { onDateSelectChange } from "../Resource/WorkflowHelper";
import { ActivityStatus } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ActivityStatus";

export interface DashboardFilterStoreState {
    isLoading?: boolean;
    actionType: ActionType;
    pressedId?: number;
    data?: any[];
    adverIds?: any[];
}

export class DashboardFilterStoreStatic extends BaseStore<DashboardFilterStoreState> {
    constructor() {
        super();
        this.subscribeToDispatcher(DashboardFilterDispatcher, (actionData) =>
            this.onDashboardFilterStoreResponse(actionData)
        );
    }

    public getLastResult(): DashboardFilterStoreState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getPressedId() {
        return this.getState().pressedId;
    }

    public getAdviserIds() {
        return this.getState().adverIds;
    }

    public getDefaultFilter(isActivity: boolean): ClientDashboardFiltersModel {
        const { toDateSelected, fromDateSelected } = onDateSelectChange(
            DateRangeOptionTypeMap[DateRangeOptionType.PastMonth]
        );
        if (isActivity) {
            //default filter for activity tab
            return {
                DateRangeOption: DateRangeOptionType.PastMonth,
                FilterActivityType: ProcessType.NotSpecified,
                FilterActivityStatus: ActivityStatus.NotSpecified,
                FilterType: FilterType.Workflow,
                FilterProductType: SubAccountType.NotSpecified,
                AdviserIds: [],
                Network: null,
                CompanyCode: null,
                EndDate: JsonDateParser.toJsonDateNoOffset(toDateSelected),
                BeginDate: JsonDateParser.toJsonDateNoOffset(fromDateSelected),
            };
        } else {
            //default filter for dashboard page
            return {
                DateRangeOption: DateRangeOptionType.PastMonth,
                FilterActivityType: ProcessType.NotSpecified,
                FilterActivityStatus: ActivityStatus.Pending,
                FilterType: FilterType.Workflow,
                FilterProductType: SubAccountType.NotSpecified,
                AdviserIds: [],
                Network: null,
                CompanyCode: null,
                EndDate: JsonDateParser.toJsonDateNoOffset(toDateSelected),
                BeginDate: JsonDateParser.toJsonDateNoOffset(fromDateSelected),
            };
        }
    }

    public convertDashboardFilterToQuery(
        filter: ClientDashboardFiltersModel,
        curPage: number,
        headAccountHierarchyIds: string[],
        subAccountHierarchyIds: string[],
        customerId: number
    ) {
        if (filter.DateRangeOption != DateRangeOptionType.Custom && DateRangeOptionTypeMap[filter.DateRangeOption]) {
            const { toDateSelected, fromDateSelected } = onDateSelectChange(
                DateRangeOptionTypeMap[filter.DateRangeOption]
            );
            filter.EndDate = JsonDateParser.toJsonDateNoOffset(toDateSelected);
            filter.BeginDate = JsonDateParser.toJsonDateNoOffset(fromDateSelected);
        }
        return {
            beginDate: filter.BeginDate,
            endDate: filter.EndDate,
            advisers: filter.AdviserIds || [],
            product: filter.FilterProductType,
            status: filter.FilterActivityStatus,
            activity: filter.FilterActivityType,
            company: filter.CompanyCode,
            network: filter.Network,
            start: (curPage - 1) * 10 + 1,
            count: 10,
            topFilterType: filter.TopFilterType || 0,
            headAccountHierarchyIds: CommonHelper.isNullOrEmpty(headAccountHierarchyIds) ? [] : headAccountHierarchyIds,
            subAccountHierarchyIds: CommonHelper.isNullOrEmpty(subAccountHierarchyIds) ? [] : subAccountHierarchyIds,
            customerId: customerId,
        };
    }

    public getFilterItemById(id: number) {
        if (CommonHelper.isNullOrEmpty(id)) {return this.getDefaultFilter(false);}
        const findObj = this.getState().data.find((ele) => ele.FilterId == id);
        return findObj;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): DashboardFilterStoreState {
        return { actionType: ActionType.Loading, data: null, pressedId: null };
    }

    private onDashboardFilterStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, pressedId: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType, adverIds: actionData.payload });
                break;
        }
    }
}
